import { Directive, Input } from '@angular/core';
import { DynamicItemBaseComponent } from './dynamic-item.base-component';
import { DynamicRenderService } from '../../services';

/* eslint-disable */
/**
 * Base level abstraction for all form element components. With required dynamicService.
 */
// this isn't that amazing of a way to do this, as casting it to DynamicItemBaseComponent
// will technically allow you to set it to undefined (not sure if angular @Input will hate that somehow),
// but it's going to work well enough, because either you will use a component directly in a template
// and get forced to assign it, or it gets used from dynamic code that will also always assign it
@Directive()
export abstract class RequiredDynamicItemBaseComponent extends DynamicItemBaseComponent {
  @Input({ required: true })
  override dynamicService: DynamicRenderService = undefined!;
}
